import { call, put, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "@p81-common/shell-core-js/dist/redux/sslCertificatesGet";

function* sslCertificatesGet(action) {
  try {
    let response = yield call(
      requestWithSubTenantIfNeeded,
      "get",
      "ssl-certificates"
    );

    yield put(actions.requestSuccess(response.data));
  } catch (e) {
    yield put(actions.requestFailure(e));
  }
}

function* saga() {
  yield takeEvery(actions.SSL_CERTIFICATES_GET_REQUEST, sslCertificatesGet);
}

export default saga;
